const require_runtime = require('../../_virtual/_rolldown/runtime.cjs');

//#region src/types/plugins/ContainerPlugin.ts
var ContainerPlugin_exports = /* @__PURE__ */ require_runtime.__exportAll({});

//#endregion
Object.defineProperty(exports, 'ContainerPlugin_exports', {
  enumerable: true,
  get: function () {
    return ContainerPlugin_exports;
  }
});
//# sourceMappingURL=ContainerPlugin.cjs.map